export default async function HolidayPromoSetup() {
  const holidayBanner = document.querySelector("a.holiday-banner")
  if (!holidayBanner) return

  let holidayModalLoaded = false
  const signedInUser = !!window.App.user?.id
  if (signedInUser && !window.ReactRailsUJS) {
    try {
      const ReactRailsUJS = await import("./react_ujs")
      const HolidayModal = await import("app/components/upgrade_plan_modal/holiday_modal")
      const { initSentryReact } = await import("app/scripts/sentry_react_setup")

      initSentryReact()

      window.App.Comps = window.App.Comps || {}
      window.App.Comps["HolidayModal"] = HolidayModal.default

      ReactRailsUJS.default.mountComponents()
      holidayModalLoaded = true
    } catch {
      // Dynamic import failed (e.g., CSS preload error). Fall back to redirect behavior.
      window.App.Utils?.logCustomDatadogAction?.("holiday_modal_load_failed")
      window.App.Comps["HolidayModal"] = {}
    }
  }

  holidayBanner.addEventListener("click", ev => {
    window.App.Utils?.logCustomDatadogAction?.("holiday_banner_click")

    if (window.ReactRailsUJS && holidayModalLoaded) {
      ev.preventDefault()
    } else {
      window.App.Utils?.logCustomDatadogAction?.("holiday_checkout_redirect")
      window.location.href = holidayBanner.getAttribute("href")
    }
  })
}
